import { Navigate } from "react-router-dom";

// Legacy route → use the unified, auto-scaling GamePlayer (no scrollbar).
export default function MemoryMatch() {
  return <Navigate to="/pti-play/inkdrops-memory-match" replace />;
}
